import {GAME_SET} from "../myResultsActions";
import {RANKING_SET} from "../../Ranking/rankingReducer";

export const classificationsReducer = (state = {
    general: [],
    stages: [],
    current: null,
}, action) => {
    switch (action.type) {
        case GAME_SET:
            if (action.payload.classifications) {
                return {...action.payload.classifications};
            }
            return {
                general: [],
                stages: [],
            };
        case RANKING_SET:
            return {
                ...state,
                current: state.general.find(c => c.id === String(action.payload.classificationId))
                    || state.stages.find(c => c.id === String(action.payload.classificationId))
            };
        default:
            return state;
    }
};